import type { BookingSearch } from "@/lib/bookingSearch"
import { buildCachedPayload } from "@/lib/caching/buildPayload"
import { Mirror } from "@/lib/mirror"

export const emptyBookingSearchBusinessesPayload =
  buildCachedPayload<BookingSearch.BusinessMirror>({
    cachedAt: 0,
    data: Mirror.build(),
  })
